import type { CatalogItem } from '@/entities/catalog-item';
import type { SymbolKey } from '@/entities/symbol';

/**
 * Composite row identity for the catalog table: no single field on
 * `CatalogItem` is unique on its own (the same `Code` repeats once per
 * period row). Shared by the table's `getRowId` (so `row.id` is stable
 * across sorting/filtering) and anything that needs to match a `SymbolKey`
 * against a `row.id` (e.g. the "show selected only" frozen snapshot) — a
 * `SymbolKey` structurally satisfies the same shape.
 */
export function getCatalogRowId(
  item: Pick<CatalogItem, 'Code' | 'Period' | 'PeriodType' | 'TimeRef'> | SymbolKey
): string {
  return `${item.Code}|${item.PeriodType}|${item.Period}|${item.TimeRef}`;
}
